import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Navbar() {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => { setOpen(false); }, [pathname]);

  const doLogout = () => { logout(); navigate('/'); };

  const navStyle = {
    position: 'fixed', top: 0, left: 0, right: 0, zIndex: 200,
    background: scrolled ? 'rgba(15,14,23,0.96)' : 'transparent',
    backdropFilter: scrolled ? 'blur(16px)' : 'none',
    borderBottom: scrolled ? '1px solid rgba(255,255,255,0.06)' : '1px solid transparent',
    transition: 'all 0.3s ease',
  };

  return (
    <>
      <nav style={navStyle}>
        <div className="container" style={{ display:'flex', alignItems:'center', justifyContent:'space-between', height: 64 }}>
          {/* Logo */}
          <Link to="/" style={{ display:'flex', alignItems:'center', gap: 10, textDecoration:'none' }}>
            <span style={{ fontSize:'1.5rem' }}>📖</span>
            <span style={{ fontFamily:'var(--font-d)', fontSize:'1.5rem', fontWeight:700, color:'var(--text)', letterSpacing:'-0.01em' }}>
              Book<span style={{ color:'var(--gold)' }}>Pub</span>
            </span>
          </Link>

          {/* Desktop links */}
          <div style={{ display:'flex', alignItems:'center', gap: 32 }} className="nav-desktop">
            {[['Browse', '/books'], ...(isAdmin ? [['Admin', '/admin']] : [])].map(([label, to]) => (
              <Link key={to} to={to} style={{
                color: pathname === to ? 'var(--gold)' : 'var(--text2)',
                fontWeight: 700, fontSize:'0.83rem', letterSpacing:'0.07em',
                textTransform:'uppercase', transition:'color 0.2s',
              }}>{label}</Link>
            ))}
          </div>

          {/* Auth */}
          <div style={{ display:'flex', alignItems:'center', gap: 12 }} className="nav-desktop">
            {user ? (
              <>
                <Link to="/dashboard" style={{ color:'var(--text2)', fontSize:'0.83rem', fontWeight:700, textTransform:'uppercase', letterSpacing:'0.07em' }}>
                  Library
                </Link>
                <div style={{ width:1, height:18, background:'var(--border2)' }} />
                <span style={{ color:'var(--text3)', fontSize:'0.82rem' }}>Hi, {user.name.split(' ')[0]}</span>
                <button className="btn btn-ghost btn-sm" onClick={doLogout}>Logout</button>
              </>
            ) : (
              <>
                <Link to="/login" className="btn btn-ghost btn-sm">Login</Link>
                <Link to="/register" className="btn btn-gold btn-sm">Join Free</Link>
              </>
            )}
          </div>

          {/* Hamburger */}
          <button onClick={() => setOpen(o => !o)} style={{ background:'none', border:'none', color:'var(--text)', fontSize:'1.4rem', cursor:'pointer', display:'none' }} className="nav-ham">
            {open ? '✕' : '☰'}
          </button>
        </div>
      </nav>

      {/* Mobile drawer */}
      {open && (
        <div style={{ position:'fixed', top:64, left:0, right:0, bottom:0, background:'var(--bg)', zIndex:190, padding:'32px 24px', display:'flex', flexDirection:'column', gap:4 }}>
          {[['Browse Books', '/books'], ...(isAdmin ? [['Admin Panel', '/admin']] : []), ...(user ? [['My Library', '/dashboard']] : [])].map(([label, to]) => (
            <Link key={to} to={to} style={{ padding:'16px 0', color:'var(--text)', fontSize:'1.4rem', fontFamily:'var(--font-d)', borderBottom:'1px solid var(--border)' }}>
              {label}
            </Link>
          ))}
          <div style={{ marginTop: 24 }}>
            {user ? (
              <button className="btn btn-ghost" onClick={doLogout} style={{ width:'100%' }}>Logout</button>
            ) : (
              <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
                <Link to="/login" className="btn btn-ghost" style={{ textAlign:'center' }}>Login</Link>
                <Link to="/register" className="btn btn-gold" style={{ textAlign:'center' }}>Join Free</Link>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Spacer */}
      <div style={{ height: 64 }} />

      <style>{`
        @media (max-width: 768px) {
          .nav-desktop { display: none !important; }
          .nav-ham { display: flex !important; }
        }
      `}</style>
    </>
  );
}
